document.addEventListener('DOMContentLoaded', function () {
  const countryOptions = document.querySelector('#shipping_country');
  const provinceContainer = document.querySelector('.province_container');
  const pincodeContainer = document.querySelector('.pincode_container');
  const calculateContainer = document.querySelector('.calculate_container');
  const calculateButton = calculateContainer.querySelector('#calculate_shipping');

  if (!countryOptions) return;

  function handleCountryChange() {
    const selectedCountry = countryOptions.options[countryOptions.selectedIndex];
    const selectedCountryValue = selectedCountry.value;

    // Reset UI
    provinceContainer.classList.add('hidden');
    pincodeContainer.classList.add('hidden');
    calculateContainer.classList.add('hidden');
    provinceContainer.innerHTML = '';

    // Ignore placeholder / blank value
    if (!selectedCountryValue || selectedCountryValue.trim() === '---') {
      return;
    }

    const provincesRaw = selectedCountry.getAttribute('data-provinces');
    if (!provincesRaw) {
      pincodeContainer.classList.remove('hidden');
      calculateContainer.classList.remove('hidden');
      return;
    }

    const provinceData = JSON.parse(provincesRaw);

    // No provinces → show pincode + calculate
    if (provinceData.length === 0) {
      pincodeContainer.classList.remove('hidden');
      calculateContainer.classList.remove('hidden');
      return;
    }

    // Build province dropdown
    provinceContainer.classList.remove('hidden');
    provinceContainer.innerHTML = `
      <label for="shipping_province">Select Province:</label>
      <select name="province" id="shipping_province">
        <option value="">Select Province</option>
      </select>
    `;

    const provinceSelect = provinceContainer.querySelector('#shipping_province');

    provinceData.forEach(([name, value]) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = name;
      provinceSelect.appendChild(option);
    });

    // Province change handler
    provinceSelect.addEventListener('change', function () {
      if (this.value) {
        pincodeContainer.classList.remove('hidden');
        calculateContainer.classList.remove('hidden');
      } else {
        pincodeContainer.classList.add('hidden');
        calculateContainer.classList.add('hidden');
      }
    });
  }

  // 🔁 Run on change
  countryOptions.addEventListener('change', handleCountryChange);

  // ✅ Run once on page load (if country already selected)
  if (countryOptions.value && countryOptions.value.trim() !== '---') {
    handleCountryChange();
  }

  calculateButton.addEventListener('click', function () {
    const selectedCountryValue = countryOptions.value;
    const provinceSelect = provinceContainer.querySelector('#shipping_province');
    const pincodeValue = pincodeContainer.querySelector('#pincode').value;

    calculateButton.classList.add('calculating');
    calculateButton.innerText = 'Calculating....';
    calculateButton.disabled = true;

    let provinceSelectedValue = null;
    if (provinceSelect) {
      provinceSelectedValue = provinceSelect.value;
    }
    console.log('selectedCountryValue : ', selectedCountryValue);
    console.log('provinceSelectedValue : ', provinceSelectedValue);
    console.log('pincodeValue : ', pincodeValue);

    let responseContainer = document.querySelector('.response_container');
    responseContainer.innerHTML = '';
    responseContainer.classList.remove('error');
    responseContainer.classList.remove('success');

    fetch(`/cart/prepare_shipping_rates.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        shipping_address: {
          country: selectedCountryValue,
          province: provinceSelectedValue,
          zip: pincodeValue,
        },
      }),
    })
      .then(async (response) => {
        const responseData = await response.json();
        if (!response.ok) {
          console.log('Error response:', responseData);
          responseContainer.classList.add('error');
          responseContainer.innerHTML = `
              <div class="error-msg">
                  ${
                    responseData.country
                      ? `<span>${responseData.country}</span>`
                      : responseData.zip || provinceSelectedValue
                      ? `<span>${responseData.zip ? responseData.zip : ''} ${
                          provinceSelectedValue ? provinceSelectedValue : ''
                        }</span>`
                      : ''
                  }
              </div>
              `;

          calculateButton.classList.remove('calculating');
          calculateButton.disabled = false;
          calculateButton.innerText = 'Calculate';
          throw new Error('Shipping rate preparation failed.');
        }
        console.log('Shipping rate calculation started');
        return responseData;
      })
      .then(() => {
        setTimeout(() => {
          fetch(`/cart/async_shipping_rates.json`)
            .then((res) => res.json())
            .then((data) => {
              console.log('Shipping Rates:', data.shipping_rates);

              responseContainer.classList.remove('error');
              responseContainer.classList.add('success');
              responseContainer.innerHTML = '';

              data.shipping_rates.forEach((rate) => {
                const shippingResponse = `
                          <div class="response">
                              <span>${rate.name}</span>
                              <span>${rate.price}</span>
                          </div>
                      `;
                responseContainer.innerHTML += shippingResponse;
              });
              calculateButton.classList.remove('calculating');
              calculateButton.disabled = false;
              calculateButton.innerText = 'Calculate';
            })
            .catch((err) => {
              console.log('Error fetching shipping rates:', err);
              responseContainer.classList.add('error');
              responseContainer.innerHTML = `<div class="error-msg">Error loading shipping rates.</div>`;
            });
        }, 1000);
      })
      .catch((error) => {
        console.log('Exception caught:', error);
      });
  });
});